import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authSlice from './redux/authSlice';
import companionSlice from './redux/companionSlice';
import { URL } from './redux/api';
import profilSlice from './redux/profilSlice';
import storage from 'redux-persist/lib/storage';
import { createTransform, persistReducer } from 'redux-persist';
import evenementsSlice from './redux/evenementsSlice';

// Exclude participantsCache from persist to avoid localStorage bloat
const evenementsTransform = createTransform(
  (inboundState, key) => {
    if (key === 'evenements' && inboundState && inboundState.participantsCache === undefined) {
      return { ...inboundState, participantsCache: {} };
    }
    return inboundState;
  },
  (outboundState, key) => {
    if (key === 'evenements' && outboundState?.participantsCache) {
      const { participantsCache, ...rest } = outboundState;
      return rest;
    }
    return outboundState;
  },
  { whitelist: ['evenements'] }
);

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  transforms: [evenementsTransform],
};
const combinedReducer = combineReducers({
  user: authSlice,
  companion: companionSlice,
  profil: profilSlice,
  // circleBar: circleSlice,
  evenements: evenementsSlice,
});

const reducer = (state, action) => {
  const sessionChanged =
    ['companion/startCompanion', 'companion/exitCompanion', 'companion/expireCompanion'].includes(
      action.type
    ) ||
    (action.type === 'user/addAccess' && action.payload && state?.companion?.token);
  if (sessionChanged) state = { ...state, profil: undefined, evenements: undefined };
  const next = combinedReducer(state, action);
  if (action.type === 'companion/startCompanion') {
    const { event } = action.payload;
    next.evenements = {
      ...next.evenements,
      evenementSelect: event,
      planSelected: event.plan ? `${URL}/plan-view/${event.id}/preview` : '',
    };
  }
  return next;
};
const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
});

export default store;
